import { Component } from 'react'

export class ScrollToTop extends Component {
  componentDidUpdate = () => window.scrollTo(0, 0)
  render = () => this.props.children
}



// WEBPACK FOOTER //
// ./src/ui/elements/ScrollToTop.js